export enum ClaimTypes {
  Role = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
  GivenName = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname',
  Surname = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname',
  UserName = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name',
  Email = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress',
}
